var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-rating',{attrs:{"color":"amber","background-color":"grey lighten-2","empty-icon":"mdi-star","small":"","dense":"","readonly":"","value":parseInt(_vm.hotel.category)}})
}
var staticRenderFns = []

export { render, staticRenderFns }